import { getCurrentDateWithDay } from "@/helpers/format-date";
import { labelHeader } from "../../constants/label-header-constant";
import { forecastDataType } from "@/schemas/prevision-data-schema";
import { getForecastByDate } from "@/helpers/format-forecast-data-by-date";

import PrevisionTable from "@/components/prevision-table/PrevisionTable";

type PrevisionTableProps = {
	dateSelected: Date;
	data: forecastDataType[];
};

export const PrevisionTableForecast = ({
	dateSelected: dateSelectedProps,
	data,
}: PrevisionTableProps) => {
	const dateSelected = new Date(dateSelectedProps);

	const { day, date } = getCurrentDateWithDay(dateSelected);

	const dataToMap = getForecastByDate({
		selectedDate: dateSelected,
		forecastData: data,
	});

	return (
		<PrevisionTable
			labelHeader={labelHeader}
			date={date}
			day={day}
			data={dataToMap}
			type="terrestrial"
		/>
	);
};

export default PrevisionTableForecast;
